<template>
  <div>
    <PageHeader>
      <!--          <el-tabs v-model="activeTabKey" @tab-click="handleClick">-->
      <!--            <el-tab-pane label="DTU任务列表" name="first" v-if="dtuRole"></el-tab-pane>-->
      <!--            <el-tab-pane label="下位机任务列表" name="second" v-if="lowerRole"></el-tab-pane>-->
      <!--          </el-tabs>-->
    </PageHeader>
    <TaskDtu :role="dtuRoleChildList" />
    <!--    <TaskLower v-if="activeTabKey === 'second'" :role="lowerRoleChildList" />-->
  </div>
</template>

<script>
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'

import TaskDtu from './TaskDtu'
// import TaskLower from './TaskLower'
export default {
  mixins: [getRoleFromPath],
  components: {
    TaskDtu
    // TaskLower
  },
  data() {
    return {
      activeTabKey: 'first'
    }
  },
  created() {
    if (this.dtuRole) {
      this.activeTabKey = 'first'
    } else if (this.lowerRole) {
      this.activeTabKey = 'second'
    }
  },
  computed: {
    roleChildList() {
      const role = this.role.operationCode === 'task' && this.role.isPermission === 'Y'
      return role ? this.role.childList : []
    },
    // DTU任务列表
    dtuRole() {
      let dtuRole = getRoleByOperationCode(this.roleChildList, 'task_dtu')
      if (dtuRole) {
        let val = getRoleByOperationCode(dtuRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    dtuRoleChildList() {
      let dtuRole = getRoleByOperationCode(this.roleChildList, 'task_dtu')
      return dtuRole ? dtuRole.childList : []
    },
    // 下位机任务列表
    lowerRole() {
      let lowerRole = getRoleByOperationCode(this.roleChildList, 'task_lower')
      if (lowerRole) {
        let val = getRoleByOperationCode(lowerRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    lowerRoleChildList() {
      let lowerRole = getRoleByOperationCode(this.roleChildList, 'task_lower')
      return lowerRole ? lowerRole.childList : []
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin-left: 64px;
  float: left;
}
</style>
